import React from "react";
import { testSessionLoader } from "../../../loaders/helpers";
import { redirect, useLoaderData } from "react-router-dom";
import { announcementList } from "../../../api/announcement";
import TabLayout from "../../helpers/TabLayout";
import AnnouncementsTable from "./AnnouncementsTable";

const announcementsTabLoader = async (params) => {
  await testSessionLoader(params);
  const url = new URL(params.request.url);
  let page = Number(url.searchParams.get("page"));
  page = isNaN(page) ? 0 : page;
  const announcementListRes = await announcementList(page);
  const announcements = announcementListRes.data;
  if (!announcements.length && page !== 0) throw redirect("?page=0");
  return { announcements, page };
};

const AnnouncementsTab = () => {
  const { announcements } = useLoaderData();
  let { page } = useLoaderData();

  const onPageButtonClicked = (newPage) => page = newPage;

  return (
    <TabLayout
      headerLabel="Announcements"
      skeletonLines={16}
    >
      <AnnouncementsTable
        announcements={announcements}
        currentPage={page}
        onPageButtonClicked={onPageButtonClicked}
      />
    </TabLayout>
  );
};

export { announcementsTabLoader };
export default AnnouncementsTab;